/**
 * Application configuration
 */

// In React, environment variables are embedded at build time
const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

// Validate OpenAI API key format
const isValidOpenAIKey = (key) => {
  if (!key) return false;
  // Support both standard and project-scoped keys
  return key.startsWith('sk-') || key.startsWith('sk-proj-');
};

// Log environment status in development
if (process.env.NODE_ENV === 'development') {
  const keyLength = OPENAI_API_KEY?.length || 0;
  const keyPrefix = OPENAI_API_KEY?.substring(0, 8) || '';
  console.log('OpenAI API Key Status:', {
    isSet: !!OPENAI_API_KEY,
    length: keyLength,
    format: keyLength > 0 ? `${keyPrefix}...${OPENAI_API_KEY.substring(keyLength - 4)}` : 'not set',
    isValid: isValidOpenAIKey(OPENAI_API_KEY),
    environment: process.env.NODE_ENV
  });
}

const config = {
  /**
   * API endpoint prefixes
   */
  apiPrefixes: {
    // Base API endpoints
    v1: '/popin/api/1.0',
    v2: '/api',
    
    // Feature-specific endpoints
    ai: '/api/ai', // AI insights and models endpoint
    events: '/popin/api/1.0/events', // Events endpoint
    dash: '/popin/api/1.0/dash',
    pdf: '/popin/pdf'
  },
  
  /**
   * Default settings
   */
  defaults: {
    // Default AI model to use if none is selected
    aiModel: 'gpt-4',
    
    // Default cache TTL in seconds
    aiCacheTTL: 3600, // 1 hour

    // OpenAI configuration
    openai: {
      apiKey: isValidOpenAIKey(OPENAI_API_KEY) ? OPENAI_API_KEY : null,
      model: 'gpt-4',
      temperature: 0.7,
      maxTokens: 2000
    }
  }
};

export default config;
